import React, { FC } from 'react';
import { useLocation, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { ConfirmationPage as ConfirmationPagePk } from 'omni-package-react-core';
import { P } from 'ia-react-core';
import Constants from '../../Constants';

export interface ConfirmationPageProps { }

const ConfirmationPage: FC<ConfirmationPageProps> = () => {
  const { t } = useTranslation('ConfirmationPage');
  const { messageId } = useParams<{ messageId: string }>();
  const title = t('information.title');
  const children = <P> {t('information.confirmationNumber', { msgId: messageId })} </P>;
  const { search } = useLocation();
  const messageSource = new URLSearchParams(search).get('messageSource');
  const redirectTo = `${Constants.BasePagePath}?messageSource=${messageSource}`;

  return (
    <ConfirmationPagePk title={title} redirect={redirectTo}>
      {children}
    </ConfirmationPagePk>
  );
};
export default ConfirmationPage;
